import { useTheme } from "@emotion/react";
import { Grid, TextField, Typography } from "@mui/material";

import React from "react";

const LoginInput = ({ type, name, label, placeholder, value, onChange }) => {
  const theme = useTheme();

  return (
    <Grid container alignItems="center">
      <Grid item xs={12}>
        <Typography sx={{color:theme.palette.secondary.main,fontWeight:"600",marginBottom:"15px",fontSize:"15px"}}>{label}</Typography>
        <TextField
          margin="normal"
          type={type}
          required
          fullWidth
          id={name}
          name={name}
          autoComplete={type === "password" ? "current-password" : "username"}
          placeholder={placeholder}
          autoFocus
          InputLabelProps={{
            sx: {
              fontSize: "1rem",
             
            },
          }}
          sx={{
               margin:"0",
            "& .MuiOutlinedInput-root": {
                padding: "10px 14px",
               border: "0px solid #bcd9f4 ",
              borderRadius:"5px",
              "& input": {
                fontSize: "16px",
                color: theme.palette.secondary.main,
                padding:"0"
              },
              "& fieldset": {
                borderColor: theme.palette.third.main,
              },
              "&:hover fieldset": {
                borderColor: theme.palette.primary.main,
              },
              "&.Mui-focused fieldset": {
                borderColor: theme.palette.primary.main,
              },
            },
          }}
          value={value}
          onChange={onChange}
        />
      </Grid>
    </Grid>
  );
};

export default LoginInput;
